import { Link } from "react-router-dom"
import { all_routes } from "../../router/all_routes"
import StudentLeavePanel from "../student-leave/StudentLeavePanel"

// Disciplinary, imposed directly by the school — no request/approve step,
// unlike Leave Management (/hrm/list-leaves), which also has a Students tab
// for a student's own requested leave using the same underlying mechanic.
const StudentSuspensionPage = () => {
  const routes = all_routes

  return (
    <div className="page-wrapper">
      <div className="content">
        <div className="mb-3">
          <h3 className="page-title mb-1">Student Suspensions</h3>
          <p className="text-muted mb-0">
            Marks a student's attendance as Suspended over a date range. For a
            student's own requested leave, use{" "}
            <Link to={routes.listLeaves}>Leave Management</Link> instead.
          </p>
        </div>
        <StudentLeavePanel type="suspension" />
      </div>
    </div>
  )
}

export default StudentSuspensionPage
